import InputField from '@/components/inputField';
import { createRef, useRef } from 'react';
import { containerState } from '../../constant';
import { ChatFormContainer, ChatFormWrapper, SubmitButton } from './styled';

const ChatForm = (props) => {
  // 聊天配置数据、设置存储表单数据函数、设置表单显示隐藏状态函数
  const { chatConfig, setFormData, setContainer, device, formData } = props;
  // 获取表单中间的图标、表单字段对象
  const { chatFormIcon, preChatForm } = chatConfig;
  // 表单字段列表
  const formFieldArray = preChatForm.inputFields;
  // 表单字段元素，用于校验值时使用
  const inputRefs = useRef(formFieldArray.map((field) => createRef()));

  /**
   * 表单输入框变化事件，用于存储值
   * @param name 输入框的code
   * @param value 输入框的值
   */
  const handleInputDataChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /**
   * 点击表单的提交按钮
   * @param e
   */
  const submitForm = (e) => {
    e.preventDefault();

    let isValid = true;

    inputRefs.current.forEach((inputRef) => {
      const valid = inputRef.current.validate();
      if (!valid) isValid = false;
    });
    if (!isValid) {
      return;
    }
    let localFormData = {
      username: formData.chat_user_name,
      userEmail: formData.chat_email,
      phoneNumber: formData.chat_phone_number,
    };
    // 存储form到本地
    window.localStorage.setItem('goclouds-chat-form', JSON.stringify(localFormData));

    // 切换页面状态
    // setContainer(containerState.CHAT_WIDGET);
    // 判断是否是只开启在线通话、在线视频
    if (chatConfig.isVideoContainer) {
      setContainer(containerState.VIDEO);
    } else {
      setContainer(containerState.CHAT_WIDGET);
    }
  };
  const getValue = (item) => {
    switch (item.code) {
      case 'chat_user_name':
        return formData.chat_user_name;
      case 'chat_email':
        return formData.chat_email;
      case 'chat_phone_number':
        return formData.chat_phone_number;
    }
    return '';
  };

  return (
    <ChatFormContainer $device={device}>
      <img src={chatFormIcon} alt="" />
      <ChatFormWrapper onSubmit={submitForm}>
        {formFieldArray.map((field) => (
          <InputField
            $device={device}
            chatThemeColor={chatConfig.chatThemeColor}
            chatLanguage={chatConfig.chatLanguage}
            key={formFieldArray.indexOf(field)}
            ref={inputRefs.current[formFieldArray.indexOf(field)]}
            name={field.code}
            label={field.name}
            value={getValue(field)}
            onChange={handleInputDataChange}
            validation={field.validation ? field.validation : 'notRequired'}
          />
        ))}
        <SubmitButton $device={device} $themecolor={chatConfig.chatThemeColor}>
          {chatConfig.chatSubmit}
        </SubmitButton>
      </ChatFormWrapper>
    </ChatFormContainer>
  );
};

export default ChatForm;
